import { IProductsAction, IProductsData } from 'models/product/products';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IStore } from 'redux/IStore';
import { IUserPreferences } from 'models/user/userpreferences';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';

/** Action Types */
export const REQUEST_START: string = 'youmayalsolikeproducts/REQUEST_START';
export const REQUEST_FAILURE: string = 'youmayalsolikeproducts/REQUEST_FAILURE';
export const GET_SUCCESS: string = 'youmayalsolikeproducts/GET_SUCCESS';
export const LIKE_ITEM_SUCCESS: string = 'youmayalsolikeproducts/LIKE_ITEM_SUCCESS';
export const LIKE_REQUEST_START: string = 'youmayalsolikeproducts/LIKE_REQUEST_START';
export const LIKE_REQUEST_FAILURE: string = 'youmayalsolikeproducts/LIKE_REQUEST_FAILURE';
export const WISHLIST_ITEM_SUCCESS: string = 'youmayalsolikeproducts/WISHLIST_ITEM_SUCCESS';

/** Initial State */
const initialState: IProductsData = {
	items: [],
	isFetching: false,
	isFetchingLikes: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
};

/** Reducer */
export function youMayAlsoLikeProductsReducer(state = initialState, action: IProductsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case WISHLIST_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case LIKE_REQUEST_START:
			return Object.assign({}, state, {
				isFetchingLikes: true,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetchingLikes: false,
			});

		case LIKE_REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetchingLikes: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getYouMayAlsoLikeProducts(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		const data: any = {
			CurrentPage: 1,
			ItemsPerPage: 5,
		};

		const userPreferences: IUserPreferences = getState().userPreferences;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/' + id + '/Similar',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(data),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getSuccess(res.items));
						const likes = new Likes(LikeNodeType.ProductsYouMayAlsoLike);
						const wishlists = new Wishlists(WishlistNodeType.ProductsYouMayAlsoLike);
						if (userPreferences && userPreferences.id) {
							dispatch(likes.getLikedItems());
							dispatch(wishlists.getWishlistedItems());
						} else {
							dispatch(likes.updateLikeItems(null));
							dispatch(wishlists.updateWishlistItems(null));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IProductsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getSuccess(items: IProductListItemCard[]): IProductsAction {
	return {
		type: GET_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IProductsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function likeItemSuccess(): IProductsAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function likeRequestStart(): IProductsAction {
	return {
		type: LIKE_REQUEST_START,
	};
}

/** Action Creator */
export function likeRequestFailure(message: any): IProductsAction {
	return {
		type: LIKE_REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function wishlistItemSuccess(): IProductsAction {
	return {
		type: WISHLIST_ITEM_SUCCESS,
	};
}
